const AdEvents = [
    'adBreakStarted',
    'adBreakEnded',
    'adStarted',
    'adEnded',
    'adTimeupdate',
    'adCuePoints',
];

export default AdEvents;



// WEBPACK FOOTER //
// ./src/js/events/ad-events.js